module.exports = __webpack_public_path__ + "static/media/symptoms-image-1@3x.cbbcd91f.png";